export default{
    //登录接口
    apiStaffPclogin: '/staff/pclogin',
    apiStaffAdd: '/staff/add',
    apiStaffQueryList: '/staff/queryList',
    apiStaffList: '/staff/list',
    
    //获取菜单
    apiDutyList: '/duty/list',
    //根据查询条件获取菜单列表
    apiDutyQueryList: '/duty/queryList',
    //添加职责
    apiDutyAdd: '/duty/add',
    //修改职责
    apiDutyEdit: '/duty/edit',
    //删除职责
    apiDutyDel: '/duty/del',
    //获取职责树
    apiDutyTree: '/duty/tree',
    
    //获取区域列表
    apiRegionList: '/region/list',
    
    //根据查询条件获取系统参数列表
    apiSysparmQueryList: '/sysparm/queryList',
    //添加系统参数
    apiSysparmAdd: '/sysparm/add',
    //修改系统参数
    apiSysparmEdit: '/sysparm/edit',
    //删除系统参数
    apiSysparmDel: '/sysparm/del',
    //根据参数名称查询参数列表
    apiSysparmListByName: '/sysparm/listByName',
    
    //获取服务商列表
    apiFacilitatorList: '/facilitator/list',
    //根据查询条件获取服务商列表
    apiFacilitatorQueryList: '/facilitator/queryList',
    //添加服务商
    apiFacilitatorAdd: '/facilitator/add',
    //修改服务商
    apiFacilitatorEdit: '/facilitator/edit',
    //删除服务商
    apiFacilitatorDel: '/facilitator/del',
	//根据员工id查询所关联的服务商列表
	apiFacilitatorListForStaff: '/facilitator/listForStaff',
    
    //获取企业列表
    apiEnterpriseList: '/enterprise/list',
    //根据查询条件获取企业列表
    apiEnterpriseQueryList: '/enterprise/queryList',
    //添加企业
    apiEnterpriseAdd: '/enterprise/add',
    //修改企业
    apiEnterpriseEdit: '/enterprise/edit',
    
    //获取职位列表
    apiPositionsList: '/positions/list',
    //根据查询条件获取职位列表
    apiPositionsQueryList: '/positions/queryList',
    //添加职位
    apiPositionsAdd: '/positions/add',
    //修改职位
    apiPositionsEdit: '/positions/edit',
    //删除职位
    apiPositionsDel: '/positions/del',
    
    //获取职位列表
    apiDepartmentList: '/department/list',
    //根据查询条件获取职位列表
    apiDepartmentQueryList: '/department/queryList',
    //添加职位
    apiDepartmentAdd: '/department/add',
    //修改职位
    apiDepartmentEdit: '/department/edit',
    //删除职位
    apiDepartmentDel: '/department/del',
    
    //获取设备类型列表
    apiDevicetypeList: '/devicetype/list',
    //添加设备类型
    apiDevicetypeAdd: '/devicetype/add',
    //修改设备类型
    apiDevicetypeEdit: '/devicetype/edit',
    //删除设备类型
    apiDevicetypeDel: '/devicetype/del',
    
    //获取业务类型列表
    apiBusinesstypeList: '/businesstype/list',
    //添加业务类型
    apiBusinesstypeAdd: '/businesstype/add',
    //修改业务类型
    apiBusinesstypeEdit: '/businesstype/edit',
    //删除业务类型
    apiBusinesstypeDel: '/businesstype/del',
    
    //获取人群种类列表
    apiCrowdtypeList: '/crowdtype/list',
    //根据查询条件获取人群种类列表
    apiCrowdtypeQueryList: '/crowdtype/queryList',
    //添加人群种类
    apiCrowdtypeAdd: '/crowdtype/add',
    //修改人群种类
    apiCrowdtypeEdit: '/crowdtype/edit',
    //删除人群种类
    apiCrowdtypeDel: '/crowdtype/del',
    
    //获取产品列表
    apiProductList: '/product/list',
    //根据查询条件获取产品列表
    apiProductQueryList: '/product/queryList',
    //添加产品
    apiProductAdd: '/product/add',
    //修改产品
    apiProductEdit: '/product/edit',
    //删除产品
    apiProductDel: '/product/del',
    
    //价格列表(不分页)
    apiPriceList: '/price/list',
    //根据查询条件获取价格列表
    apiPriceQueryList: '/price/queryList',
    //添加价格
    apiPriceAdd: '/price/add',
    //修改价格
    apiPriceEdit: '/price/edit',
    //删除价格
    apiPriceDel: '/price/del',
    
    //获取售票站点列表
    apiTicketstationList: '/ticketstation/list',
    //根据查询条件获取售票站点列表
    apiTicketstationQueryList: '/ticketstation/queryList',
    //添加售票站点
    apiTicketstationAdd: '/ticketstation/add',
    //修改售票站点
    apiTicketstationEdit: '/ticketstation/edit',
    //删除售票站点
    apiTicketstationDel: '/ticketstation/del',
    
    //获取售票窗口列表
    apiTicketwindowList: '/ticketwindow/list',
    //根据查询条件获取售票窗口列表
    apiTicketwindowQueryList: '/ticketwindow/queryList',
    //添加售票窗口
    apiTicketwindowAdd: '/ticketwindow/add',
    //修改售票窗口
    apiTicketwindowEdit: '/ticketwindow/edit',
    //删除售票窗口
    apiTicketwindowDel: '/ticketwindow/del',
    
    //根据查询条件获取售票窗口售票权限列表
    apiSalewindowQueryList: '/salewindow/queryList',
    //获取售票窗口
    apiSalewindowGetRules: '/salewindow/getRules',
    //新增或修改售票窗口销售权限
    apiSalewindowEdit: '/salewindow/edit',
    //删除售票窗口销售权限
    apiSalewindowDel: '/salewindow/del',
    
    //获取员工售票权限
    apiSalestaffGetRules: '/salestaff/getRules',
    //新增或修改员工销售权限
    apiSalestaffEdit: '/salestaff/edit',
    //根据查询条件获取售票员工售票权限列表
    apiSalestaffQueryList: '/salestaff/queryList',
    //删除售票窗口销售权限
    apiSalestaffDel: '/salestaff/del',
    
    //获取检票园门列表
    apiCheckstationList: '/checkstation/list',
    //根据查询条件获取检票园门列表
    apiCheckstationQueryList: '/checkstation/queryList',
    //添加检票园门
    apiCheckstationAdd: '/checkstation/add',
    //修改检票园门
    apiCheckstationEdit: '/checkstation/edit',
    //删除检票园门
    apiCheckstationDel: '/checkstation/del',
    
    //获取售票流水列表
    apiOrdersQueryList: '/orders/queryList',
	//根据订单编号，获取门票列表
	apiOrderdetailsQueryAll: '/orderdetails/queryAll',
	
	//获取预制票仓库列表
	apiPflibraryList: '/pflibrary/list',
	//根据查询条件获取预制票仓库列表
	apiPflibraryQueryList: '/pflibrary/queryList',
	//添加预制票仓库
	apiPflibraryAdd: '/pflibrary/add',
	//修改预制票仓库
	apiPflibraryEdit: '/pflibrary/edit',
	//删除预制票仓库
	apiPflibraryDel: '/pflibrary/del',
	
	//获取预制票票号规则列表
	apiPfruleList: '/pfrule/list',
	//根据查询条件获取预制票票号规则列表
	apiPfruleQueryList: '/pfrule/queryList',
	//添加预制票票号规则
	apiPfruleAdd: '/pfrule/add',
	//修改预制票票号规则
	apiPfruleEdit: '/pfrule/edit',
	//删除预制票票号规则
	apiPfruleDel: '/pfrule/del',
	
	//根据查询条件获取预制票领用列表
	apiPfoutQueryList: '/pfout/queryList',
	//添加预制票领用记录
	apiPfoutAdd: '/pfout/add',
	
	//获取预制票票号规则列表
	apiInventoryList: '/inventory/list',
	//根据查询条件获取库存设置
	apiInventoryQueryList: '/inventory/queryList',
	//添加库存设置
	apiInventoryAdd: '/inventory/add',
	//修改库存设置
	apiInventoryEdit: '/inventory/edit',
	
	//根据查询条件获取库存详情
	apiInventoryDetailsQueryList: '/inventoryDetails/queryList',
	//修改库存详情
	apiInventoryDetailsEdit: '/inventoryDetails/edit',
	
}